module.exports = __webpack_public_path__ + "img/login-temporal.bdc3680.jpg";